import { HorseGeneralTipsModel } from './HorseGeneralTipsModel';
import { HorseTipsterModel } from './HorseTipsterModel';
import { HorsePackagedTipsModel } from './HorsePackagedTipsModel';

export class HorseTipsPackageModel extends HorseGeneralTipsModel {
  keyRaces: Array<Number>;
  packagedTips: Array<HorsePackagedTipsModel>;
  buyerCount: number;
  lastModifiedTime: string;
  publishEnded: boolean;
  raceDate: string;
  addCommentEnabled: boolean;
  profitMargin: string;
  dividend: number;

  constructor(id: number, tipster: HorseTipsterModel, price: number, notes: string, availableForPurchase: boolean, purchased: boolean,
      voucherCost: number, allowRefund: boolean, createDate: string, postDate: string, status: number, keyRaces: Array<Number>,
      packagedTips: Array<HorsePackagedTipsModel>, buyerCount: number, lastModifiedTime: string, publishEnded: boolean, raceDate: string,
      addCommentEnabled: boolean, profitMargin: string, dividend: number, imgSrc: string, image1: string, image2: string, image3: string) {
    super(id, tipster, price, notes, availableForPurchase, purchased, voucherCost, allowRefund, createDate, postDate, status, imgSrc, image1, image2, image3);
    this.keyRaces = keyRaces;
    this.packagedTips = packagedTips;
    this.buyerCount = buyerCount;
    this.lastModifiedTime = lastModifiedTime;
    this.publishEnded = publishEnded;
    this.status = status;
    this.raceDate = raceDate;
    this.addCommentEnabled = addCommentEnabled;
    this.profitMargin = profitMargin;
    this.dividend = dividend;
	}

}



// WEBPACK FOOTER //
// ./src/model/horse/HorseTipsPackageModel.ts